import React, { useState, useEffect } from 'react';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { Button, } from 'reactstrap';
import { Oval as Loader } from 'react-loader-spinner';
import Api from './api/api';
import MyStorage from './util/storage'

const Recipes = () => {
  const navigate = useNavigate()
  const [models, setModels] = useState([])
  const [option, setOption] = useState('all')
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    loadData()
  }, [])

  if (!MyStorage.isLogin()) {
    console.log('not logged in');
    navigate('/login')
    return null
  }

  const loadData = () => {
    setLoader(true)
    Api.getRecipes(
      (response) => {
        setLoader(false)
        setModels(response)
      },
      (error) => {
        setLoader(false)
      });
  };

  const editRecipe = (item) => {
    navigate('/admin/add-recipe', { state: { model: item } });
  }

  const deleteRecipe = (item) => {
    if (window.confirm('Are you sure you want to delete this recipe?')) {

      const temp = models.filter((item_, j) => {
        return item_.id !== item.id; //false will delete
      });
      setModels(temp)

      // setLoader(true)
      Api.deleteRecipe(item.id);
    }
  };

  return (
    <div className='main' style={{ padding: 0 }}>
      <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: 0 }}>
        <div style={{ color: 'blue' }}>
          Recipes
        </div>
      </div>
      <div
        style={{ width: '100%', display: 'flex', flexDirection: 'column', padding: 0 }}>
        <div style={{ padding: 20, display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'scroll' }}>

          <div style={{ display: 'flex' }}>
            <Button
              className='btn-block btn-dark'
              style={{ marginTop: 0, fontSize: 16, width: '100%', backgroundColor: 'green', borderWidth: 0, height: 40, width: 300, alignSelf: 'center' }}
              onClick={() => {
                navigate('/admin/add-recipe', { state: { model: null } });
              }}>
              Add Recipe
            </Button>
            <select
              name="option"
              id="options"
              style={{ width: 100, marginLeft: 10, paddingLeft: 10 }}
              onChange={(event) => {
                console.log(event.target.value);
                setOption(event.target.value)
              }}>
              <option value="all">All</option>
              <option value="hidden">Hidden</option>
            </select>
          </div>

          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>

            {models.map((item, index) => {
              console.log('option: ' + option);
              if (option === 'hidden' && !item.hide) {
                return null
              }
              return (
                <div style={{ width: '100%', backgroundColor: 'white', marginTop: 10, padding: 0, marginRight: 10, display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                  <div style={{ display: 'flex', backgroundColor: '#f2f2f2', padding: 10 }}>

                    <div style={{}}>
                      {item.images.length > 0 ?
                        <img
                          src={item.images.length > 0 ? item.images[0] : null}
                          style={{ backgroundColor: '#fff', width: 120, height: 120, border: '0px solid lightgray', objectFit: 'cover', marginRight: 15, alignSelf: 'center' }} />
                        :
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff', width: 120, height: 120, border: '0px solid lightgray', objectFit: 'cover', marginRight: 15, alignSelf: 'center' }}>
                          <div style={{ color: 'gray' }}>No Image</div>
                        </div>

                      }

                    </div>


                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                      <div style={{ display: 'flex', alignSelf: 'flex-start', flexDirection: 'column' }}>
                        <div style={{ fontSize: 16, display: 'flex', color: 'blue' }}>ID # {item.id}</div>
                        <div style={{ fontSize: 16, display: 'flex', marginLeft: 0 }}>{item.title}</div>
                      </div>

                      <div style={{ alignSelf: 'center', marginBottom: 0 }}>
                        <Button
                          className='btn-block btn-dark'
                          style={{ marginTop: 10, fontSize: 16, marginRight: 10, width: '100%', backgroundColor: 'orange', borderWidth: 0, height: 40, width: 100 }}
                          onClick={() => {
                            editRecipe(item)
                          }}>
                          Edit
                        </Button>
                        <Button
                          className='btn-block btn-dark'
                          style={{ marginTop: 10, fontSize: 16, width: '100%', backgroundColor: 'red', borderWidth: 0, height: 40, width: 100 }}
                          onClick={() => {
                            deleteRecipe(item)
                          }}>
                          Delete
                        </Button>
                      </div>

                      {/* <div style={{ display: 'flex' }}>
                        <div style={{ fontSize: 16, display: 'flex' }}>{item.detail}</div>
                      </div> */}

                    </div>
                  </div>



                </div>
              )
            })}
          </div>
        </div>
      </div>

      {
        loader ?
          <div style={{ position: 'absolute', display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', height: '80%', width: '80%' }}>
            <div style={{ padding: 10, backgroundColor: 'red', borderRadius: 100 }}>
              <Loader
                type="ThreeDots"
                color="white"
                height={70}
                width={70}
                visible={true} />
            </div>
          </div>
          :
          null
      }

    </div >
  );
}

export default Recipes;